import React from 'react';
import { ATMGrid, ATMHeader, ATMSegment } from 'shared-it-appmod-ui';
import FieldReadOnly from 'src/components/atoms/field/field-readonly/field-readonly.component';
import Lang from 'src/libraries/language';
import { IRequest } from 'src/models/request.model';

type IProps = {
  data: IRequest;
};

const FlightRequestEmergencyPoc: React.FC<IProps> = ({ data: { request } }) => {
  return (
    <ATMSegment>
      <ATMHeader>{Lang.TTL_REQUEST_EMERGENCY_POC}</ATMHeader>
      <ATMGrid columns={2}>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_NAME} inline>
            {request.pocName}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_ID} inline>
            {request.pocNo}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_DEPARTMENT} inline>
            {request.pocDept}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_JOB_TITLE} inline>
            {request.pocJobTitle}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMAIL} inline>
            {request.pocEmail}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_REQUEST_REQUESTOR_CONTACT} inline>
            {request.pocPhone}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_MGR_NAME} inline>
            {request.pocManagerName}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_MGR_E_MAIL} inline>
            {request.pocManagerEmail}
          </FieldReadOnly>
        </ATMGrid.Column>
      </ATMGrid>
    </ATMSegment>
  );
};

export default FlightRequestEmergencyPoc;
